import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Calendar, MapPin, Users, Mail } from 'lucide-react';

export default function BookingSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const booking = location.state?.booking;
  const type = location.state?.type;

  if (!booking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Booking not found</h2>
          <Button onClick={() => navigate('/')}>Go to Home</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="shadow-xl">
          <CardContent className="p-8 text-center">
            <div className="flex justify-center mb-6">
              <div className="rounded-full bg-green-100 p-4">
                <CheckCircle className="w-16 h-16 text-green-600" />
              </div>
            </div>

            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Booking Confirmed!
            </h1>
            
            <p className="text-lg text-gray-600 mb-8">
              Your travel package booking has been successfully placed.
            </p>

            <div className="bg-gray-50 rounded-lg p-6 mb-8 text-left">
              <h3 className="font-bold text-lg mb-4">Booking Details</h3>
              
              <div className="space-y-3">
                <div className="flex items-start">
                  <Calendar className="w-5 h-5 text-gray-500 mt-1 mr-3" />
                  <div>
                    <p className="text-sm text-gray-600">Booking ID</p>
                    <p className="font-semibold">{booking.id || booking._id}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <MapPin className="w-5 h-5 text-gray-500 mt-1 mr-3" />
                  <div>
                    <p className="text-sm text-gray-600">Package</p>
                    <p className="font-semibold">{booking.package_name}</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Users className="w-5 h-5 text-gray-500 mt-1 mr-3" />
                  <div>
                    <p className="text-sm text-gray-600">Travelers</p>
                    <p className="font-semibold">{booking.num_travelers} person(s)</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail className="w-5 h-5 text-gray-500 mt-1 mr-3" />
                  <div>
                    <p className="text-sm text-gray-600">Contact Email</p>
                    <p className="font-semibold">{booking.customer_email}</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex justify-between items-center">
                  <span className="text-lg font-semibold">Total Amount</span>
                  <span className="text-2xl font-bold text-green-700">
                    ₹{booking.total_amount.toLocaleString()}
                  </span>
                </div>
                {booking.payment_method === 'at_hotel' && (
                  <p className="text-sm text-gray-600 mt-2">
                    Payment to be made at the hotel
                  </p>
                )}
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
              <p className="text-sm text-blue-800">
                📧 A confirmation email with complete details has been sent to <strong>{booking.customer_email}</strong>
              </p>
              <p className="text-sm text-blue-800 mt-2">
                Our team will contact you within 24 hours to confirm your booking and provide further details.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => navigate('/')}
                className="bg-green-600 hover:bg-green-700"
              >
                Back to Home
              </Button>
              <Button
                onClick={() => navigate('/nammayatra')}
                variant="outline"
              >
                Browse More Packages
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
